import { useEffect } from 'react';

const IntersectionObserverFunc = (ref, func, option) => {
  useEffect(() => {
    const observer = new IntersectionObserver(func, option);

    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);
};
export default IntersectionObserverFunc;
